import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=9bb88efe&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bb88efe')) {
      api.createRecord('9bb88efe', component.options)
    } else {
      api.reload('9bb88efe', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=9bb88efe&", function () {
      api.rerender('9bb88efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zea4E1k6xWmL/JS/comp/FavElement.vue"
export default component.exports